import SectionCard from '@/components/molecule/SectionCard';
import LocalIcon from '@/components/atom/Icons/LocalIcon';
import TablePlaceholderSvg from '@/assets/icons/icon-table-placeholder.svg';
import Typo from '@/components/atom/Typo';
import React, { ReactNode } from 'react';

export interface InfoData {
  id: number;
  contents: string;
}

interface Props {
  cardTitle?: string | ReactNode;
  infoData?: InfoData[];
}

function InfoSectionCard({ cardTitle, infoData }: Props) {
  return (
    <SectionCard
      className="flex min-h-[520px] flex-col gap-4"
      cardTitle={cardTitle}
      contentProps={{
        className:
          'flex flex-col p-0 border border-gray0 flex-1 rounded-lg overflow-hidden',
      }}
    >
      <header className="bg-gray0">
        <div className="flex h-[44px] text-b14m text-gray7">
          <div className="flex w-[70px] items-center justify-center border-r border-gray1">
            No.
          </div>
          <div className="flex flex-1 items-center justify-center">내용</div>
        </div>
      </header>
      <div className="flex max-h-full flex-1 flex-col gap-6 overflow-y-auto py-3">
        {infoData &&
          infoData.map((item, idx) => (
            <div
              key={item.id || idx + 1}
              className="flex items-center text-b14r text-gray9"
            >
              <div className="flex w-[70px] items-center justify-center">
                {item.id ? idx + 1 : '신규'}
              </div>
              <div className="flex flex-1 items-center pr-4">
                {item.contents}
              </div>
            </div>
          ))}
        {!infoData ||
          (infoData?.length === 0 && (
            <div className="flex min-h-[160px] flex-col items-center justify-center gap-[4px]">
              <LocalIcon iconSrc={TablePlaceholderSvg} iconSize={56} />
              <Typo typoColor="gray2" typoType="b14r">
                데이터가 없습니다
              </Typo>
            </div>
          ))}
      </div>
    </SectionCard>
  );
}

export default React.memo(InfoSectionCard);
